import React from 'react';
import PropTypes from 'prop-types';

import TermsConditions from '../components/Admin/TermsConditions';

import { spacing, maxScreenSize } from '../lib/theme';

class TermsAndConditions extends React.Component {
    // static async getInitialProps(context) {
    //     // const queryText = context.query.text;
    //     // return { queryText };
    // }

    constructor(props) {
        super(props);
        // this.state = { podcasts: undefined, searching: true };
        // this.props.loadingUserDetailsState(true);
    }

    render() {
        return (
            <div className='list'>
                <TermsConditions />
                <style jsx>
                    {`
          .list {
            position: absolute;
            width: 100%;
            top: 0;
            left: 0;
            z-index: 100;
            background: white;
            padding: ${spacing('xxl')};
          }
          @media ${maxScreenSize.tablet} {
            .list {
                padding: ${spacing('lg')};
            }
          }
        `}
                </style>
            </div>
        )
    }
}

// CookiesDetails.propTypes = {
//     //   podcasts: PropTypes.array,
//     //   queryText: PropTypes.string
// }

// export default connect(null, null)(TermsAndConditions);
export default TermsAndConditions;
